import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/dropdown/getusers/jv",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getJvEntry(payload) {
    const resultuser = await axios.post(apiUrl + "/jv/entry",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}
export const JvService = {
    getUsers,
    getJvEntry,
}